import { getProfile,getApplication,GetProfilesByApplicationId,GetApplicationByProfileId, saveProfile, deleteProfile, getProfileById, savePermissions, getPermissions, getAllPermissionsByProfile } from '../../../shared/data-services/management-profile-service';
import { getEmployeesWithProfiles, updateProfilesByEmployee, getAllProfilesByEmployee, deleteEmployeeByProfile, getAllEmployeesByAirport, getAllEmployeesByAirportForEdit, bulkUpdateProfilesByEmployees } from '../../../shared/data-services/management-employee-service';
import { getAirports } from '../../../shared/data-services/airport-service';
import { getEmployeesByAirport, getUserFaceFeature, saveNewUser, updateUser } from '../../../shared/data-services/talmaid-service';

export async function getAllProfile (companyId){
  const data = await getProfile(companyId);
  return data || [ ];
};


export async function getApplications (companyId){
  const data = await getApplication(companyId);
  return data || [ ];
};


export async function getProfilesByApplication (Id, companyId){
  const data = await GetProfilesByApplicationId(Id, companyId);
  return data || [ ];
};

export async function getApplicationByProfile (Id, companyId){
  const data = await GetApplicationByProfileId(Id, companyId);
  return data || [ ];
};

export async function getemployeesByAirport(AirportId){
  const data = await getEmployeesByAirport(AirportId);
  return data;
}

export async function getallemployeesByAirport(AirportId, companyId){
  const data = await getAllEmployeesByAirport(AirportId, companyId);
  return data;
}

export async function getallemployeesByAirportForEdit(AirportId, companyId){
  const data = await getAllEmployeesByAirportForEdit(AirportId, companyId);
  return data;
}

export async function getAllAirports (companyId){
  const data = await getAirports(companyId);
  return data;
};

export async function getEmployees (companyId){
  const data = await getEmployeesWithProfiles(companyId);
  return data || [ ];
};

export async function updateAllProfilesByEmployee (profiles, employee){
  await updateProfilesByEmployee(profiles, employee);
  return;
};

export async function getProfilesByEmployee (employeeId, companyId){
  const data = await getAllProfilesByEmployee(employeeId, companyId);
  return data || [ ];
};

export async function getSelectedProfile (id){
  const data = await getProfileById(id);
  return data;
};

export async function saveSelectedProfile (id, description){
  const Profile = {
    id, 
    description
  }

  const data = await saveProfile(Profile);
  return data;
};


export async function getPermissionByProfile (profileId){
  const data = await getAllPermissionsByProfile(profileId);
  return data || [ ];
};

export async function getAllPermissions(){
  const data = await getPermissions();
  return data || [];
};


export async function saveSelectedPermissions (permissions, profileId, profileName, action){
  // const Permission = {
  //   code, 
  //   description: description
  // }
  if(action === 'CREAR'){
    profileId = null
  }
  const data = await savePermissions(permissions, profileId, profileName);
  return data;
};

export async function deleteSelectedProfile (id, employee){
  const data = await deleteEmployeeByProfile(id, employee);
  return data;
};

export async function bulkAssignProfiles (employeeIds, profiles, employee){
  const data = await bulkUpdateProfilesByEmployees(employeeIds, profiles, employee);
  return data;
};
